import { Avatar, Popover, Typography } from 'antd';
import type { PresenceInfo } from '../scenes/EventScene';

const { Text } = Typography;

const STATUS_COLOR: Record<PresenceInfo['status'], string> = {
  online: '#87d068',
  hidden: '#f5a623',
  offline: '#f6323a',
};

const STATUS_LABEL: Record<PresenceInfo['status'], string> = {
  online: 'Online',
  hidden: 'Window in background',
  offline: 'Offline',
};

function formatLastSeen(ts?: number): string {
  if (!ts) return 'never';
  const diff = Date.now() - ts;
  if (diff < 60_000) return 'just now';
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)} min ago`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)} hr ago`;
  return new Date(ts).toLocaleString();
}

export function PresenceDot({
  presence,
  size = 12,
}: {
  presence: PresenceInfo;
  size?: number;
}) {
  return (
    <Popover
      trigger="hover"
      content={
        <div style={{ maxWidth: 280 }}>
          <div>
            <Text strong>{STATUS_LABEL[presence.status]}</Text>
          </div>
          {presence.platform && (
            <div>
              <Text type="secondary">{presence.platform}</Text>
            </div>
          )}
          {presence.status !== 'online' && (
            <div>
              <Text type="secondary">Last seen: {formatLastSeen(presence.lastSeenAt)}</Text>
            </div>
          )}
        </div>
      }
    >
      <Avatar
        size={size}
        style={{ backgroundColor: STATUS_COLOR[presence.status], cursor: 'help' }}
      />
    </Popover>
  );
}
